import React, { FunctionComponent, useState } from 'react';

import { TimelineEntry as TimelineEntryType } from '../../../../types/__generated__';
import { Body } from './Body';
import { DeleteTimelineEntryConfirmationModal } from './DeleteTimelineEntryConfirmationModal';
import { Footer } from './Footer';
import { Header } from './Header/Header';

import styles from '../Timeline.scss';

export interface TimelineEntryProps {
  timelineEntry: TimelineEntryType;
}

export const TimelineEntry: FunctionComponent<TimelineEntryProps> = ({
  timelineEntry,
}) => {
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  const handleOpenConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const handleCloseConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
  };

  return (
    <div className={styles.timeline} data-qa="timeline-entry">
      <Header
        timelineEntry={timelineEntry}
        onDeleteEntry={handleOpenConfirmationModal}
      />
      <Body timelineEntry={timelineEntry} />
      <Footer timelineEntry={timelineEntry} />
      <DeleteTimelineEntryConfirmationModal
        timelineEntry={timelineEntry}
        isConfirmationModalOpen={isConfirmationModalOpen}
        handleCloseConfirmationModal={handleCloseConfirmationModal}
      />
    </div>
  );
};
TimelineEntry.displayName = 'TimelineEntry';
